export const LAYOUT_OPTIONS_POSITIONS: Record<string, number> = {
  dekaap: 1,
  deblaak: 2,
  demeent: 3,
  demaas: 5,
  debeursdemaas: 5,
  demaasdubbel: 5,
  debeursdemaasdubbel: 5.1,
  demaas2dubbel: 5.2,

  dewaaldubbel: 6,
  debeursdewaaldubbel: 6.1,
  debeursdewaalcutdubbel: 6.2,
  dekaapdewaaldubbel: 6.3,
  decooldewaaldubbel: 6.4,

  dewaal: 6.5,
  debeursdewaal: 6.6,
  debeursdewaalcut: 6.7,
  dekaapdewaal: 6.8,
  decooldewaal: 6.9,

  deijssel: 7,
  deijssel1: 7.1,
  deijsseldubbel: 7,
  deijssel1dubbel: 7.1,
  eigenwijs: 8,
  dewaal2: 10,
  dewaal2dubbel: 10,
  dewaal3dubbel: 11,
  dewaal4dubbel: 12,
};

export const NEW_LAYOUT_OPTIONS_POSITIONS: Record<string, number> = {
  dekaap: 6,
  deblaak: 7,
  demeent: 8,
  eigenwijs: 4,

  dewaaldubbel: 1,
  debeursdewaaldubbel: 1.1,
  debeursdewaalcutdubbel: 1.2,
  dekaapdewaaldubbel: 1.3,
  decooldewaaldubbel: 1.4,

  dewaal: 1.5,
  debeursdewaal: 1.6,
  debeursdewaalcut: 1.7,
  dekaapdewaal: 1.8,
  decooldewaal: 1.9,

  dewaal2: 10,
  dewaal2dubbel: 10,
  dewaal3dubbel: 11,
  dewaal4dubbel: 12,
  demaas: 2,
  debeursdemaas: 3,
  demaasdubbel: 2,
  debeursdemaasdubbel: 2.1,
  demaas2dubbel: 2.2,
  deijssel: 3,
  deijssel1: 3.1,
  deijsseldubbel: 3,
  deijssel1dubbel: 3.1,
};
